import React, { useState, useEffect } from 'react';

export default function SlideImage({ src, alt, fallback, eager, srcSet, sizes }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setAnimate(true), 200);
    return () => clearTimeout(timeout);
  }, []);

  // Detectar si es hero_banner_1 para aplicar escala más pequeña
  const isHeroBanner1 = src && src.includes('hero_banner_1');

  return (
    <div
      role="img"
      aria-label={alt}
      className="relative w-full h-full overflow-hidden"
    >
      {loading && (
        <div
          className="absolute inset-0 flex items-center justify-center bg-white z-10"
          aria-live="polite"
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/logo_avion_dorado_spinner.png`}
            alt="Cargando imagen"
            className="w-20 h-20 animate-bounce"
            loading="lazy"
          />
        </div>
      )}
      <img
        src={error ? fallback : src}
        srcSet={srcSet || (error ? undefined : src)}
        sizes={sizes || '100vw'}
        alt={alt}
        onLoad={() => setLoading(false)}
        onError={() => {
          setLoading(false);
          setError(true);
        }}
        loading={eager ? 'eager' : 'lazy'}
        className={`w-full h-full object-cover transition-transform duration-[2500ms] ease-in-out ${
          animate ? 'scale-105' : 'scale-100'
        }`}
        style={{ 
          willChange: 'transform',
          objectPosition: isHeroBanner1 ? 'center 30%' : 'center'
        }}
      />
    </div>
  );
}
